import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export { wrapPageElement, wrapRootElement } from 'utils';
export var onClientEntry =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof IntersectionObserver === 'undefined')) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return import('intersection-observer');

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onClientEntry() {
    return _ref.apply(this, arguments);
  };
}();